import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import styles from "./styles.module.scss";
import { useSelector } from "react-redux";
import H2Font from "Root/profile/components/common/H2Font";
import RegFont from "Root/profile/components/common/RegFont";
import { useEffect, useRef } from "react";
import { capitalize } from "Root/profile/utils";
const CheckoutResultsBanner = () => {
    const wrapperRef = useRef(null);
    const userName = useSelector((state) => state.user.name);
    const quizOptions = useSelector((state) => state.myProfile.quizOptions);
    const getFirstName = () => {
        const name = userName.split(" ");
        if (name[0].toLowerCase() === "guest") {
            return "You";
        }
        return name[0];
    };
    const selectedAnswers = useSelector((state) => state.myProfile.selectedAnswers);
    const getIconsForSelectedCategory = () => {
        const icons = [];
        if (selectedAnswers?.dietary?.length > 0 && quizOptions?.dietaryRestrictions?.dietary) {
            const dietaryIcons = quizOptions.dietaryRestrictions.dietary
                .filter((item) => selectedAnswers.dietary.find((answer) => item.value.trim().indexOf(answer) !== -1))
                .map((item) => ({
                icon: item.image,
                title: item.label,
            }));
            icons.push(...dietaryIcons);
        }
        if (selectedAnswers?.reasons?.length > 0 && quizOptions?.nutritionGoals?.nutritionGoals) {
            const reasonsIcons = quizOptions.nutritionGoals.nutritionGoals
                .filter((item) => selectedAnswers.reasons.find((answer) => item.value.trim().indexOf(answer) !== -1))
                .map((item) => ({
                icon: item.image,
                title: item.label,
            }));
            icons.push(...reasonsIcons);
        }
        if (selectedAnswers?.mainExercises?.length > 0 && quizOptions?.exersiseHabits?.mainExercises) {
            const exercisesIcons = quizOptions.exersiseHabits.mainExercises
                .filter((item) => selectedAnswers.mainExercises.find((answer) => item.value.trim().indexOf(answer) !== -1))
                .map((item) => ({
                icon: item.image,
                title: item.label,
            }));
            icons.push(...exercisesIcons);
        }
        if (selectedAnswers.weeklyFreq1) {
            icons.push({
                icon: `<span class=${styles.weekly_freq}>${selectedAnswers.weeklyFreq1}x</span>`,
                title: "week",
            });
        }
        return icons.filter((item) => item.title?.toLowerCase() !== "none");
    };
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (_jsx("div", { ref: wrapperRef, className: styles.banner_wrapper, children: _jsx("div", { className: styles.banner, children: _jsxs("div", { className: styles.title_wrapper, children: [_jsxs(H2Font, { children: ["Personalized for ", capitalize(getFirstName())] }), _jsxs(RegFont, { children: ["Learn about your recommended products. Every product is carefully personalized for you with science-backed\u00A0", _jsx(RegFont, { fontWeight: 400, children: "clean and quality ingredients" }), " tailored to your lifestyle and nutrition goals."] }), _jsx("div", { className: styles.icons, children: getIconsForSelectedCategory()
                            .slice(0, 3)
                            .map((item, i) => (_jsxs("div", { className: styles.icon, children: [_jsx("span", { dangerouslySetInnerHTML: { __html: item.icon || "" }, className: styles.icon_img }), _jsx("span", { className: styles.icon_title, children: _jsx(RegFont, { children: item.title.replace("-", " ").replace("/ plant based", "") }) })] }, `${item.title}${item.icon}${i}`))) })] }) }) }));
};
export default CheckoutResultsBanner;
